<template>
<div class="wrap">

		<!-- 面包屑导航区 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item class="test" :to="{ path: '/lianxiwomen' }">加入我们 设置</el-breadcrumb-item>
			<el-breadcrumb-item>编辑环境图片</el-breadcrumb-item>
		</el-breadcrumb>

		<el-card>
			<el-form label-width="80px" :model="formData">
				
				<el-form-item label="当前图片">
					<el-upload class="upload-demo" list-type="picture" :action="uploadUrl" :limit="1" :file-list="fileList" :on-remove="onRemove"
					 :on-success="onSuccess">
						<el-button size="small" type="primary">点击上传图片</el-button><el-tag style="margin-left: 20px;" type="danger">请删除原来的图片后，再上传图片</el-tag>
					</el-upload>
				</el-form-item>
				<!-- <el-form-item label="文章标题">
					<el-input v-model="formData.title"></el-input>
				</el-form-item>
				<el-form-item label="文章简介">
					<el-input v-model="formData.introduction"></el-input>
				</el-form-item>
				<el-form-item label="分类">
					<el-input disabled placeholder="活动"></el-input>
				</el-form-item> -->
			</el-form>
			
			<!-- 添加商品 -->
			<el-button type="success" class="submitBtn" @click="submit">立即提交</el-button>
		</el-card>

	</div>
</template>

<script>
	export default{
		data(){
			return{
				uploadUrl: this.$httpTitle + '/uploadImgQiniugroup?pathName=activityNewInfo',
				formData:{},
				fileList:[],
				fileList2:'',
				index:'',
				huajingList:[],
				detailData:{}
			}
		},
		created() {
			console.log('index='+this.$route.query.index)
			this.index = this.$route.query.index
			this.getHuangjingList();
		},
		methods:{
			async getHuangjingList() {
				/* 6.办公环境列表/v1/official/manag/environment/list  get请求 无参 也无需传request。 */
				var res = await this.$http.get('/v1/official/manag/environment/list', {
					params: {
			
					}
				})
			
				console.log('办公环境=' + JSON.stringify(res))
				if(res.data.code == 0){
					this.detailData = res.data.data.list[0]
					var obj = res.data.data.list[0];
					this.huajingList= [{url:obj.picture1,idx:0},{url:obj.picture2,idx:1},{url:obj.picture3,idx:2},{url:obj.picture4,idx:3},{url:obj.picture5,idx:4}];
					var obj2 = {};
					obj2.name = '当前点击的办公环境图片'
					obj2.url = this.$imgTitle + this.huajingList[this.index].url;
					this.fileList.push(obj2)
				}
			},
			onRemove(file, fileList) {
				console.log('fileList=' + JSON.stringify(fileList))
				this.fileList2 = '';
			},
			onSuccess(res) {
				console.log('res=' + JSON.stringify(res))
				this.fileList2=res
			},
			async submit(){
				/* 8.办公环境修改/v1/official/manag/environment/update  post请求 参数 Long id，String picture1，String picture2，
				String picture3，String picture4，String picture5，String picture6 */
				if(this.fileList2 == ''){
					return this.$message.error('请选择图片')
				}
				if(this.index == 0){
					var picture1 = this.fileList2
					var picture2 = this.huajingList[1].url
					var picture3 = this.huajingList[2].url
					var picture4 = this.huajingList[3].url
					var picture5 = this.huajingList[4].url
				}else if(this.index == 1){
					var picture1 = this.huajingList[0].url
					var picture2 = this.fileList2
					var picture3 = this.huajingList[2].url
					var picture4 = this.huajingList[3].url
					var picture5 = this.huajingList[4].url
				}else if(this.index == 2){
					var picture1 = this.huajingList[0].url
					var picture2 = this.huajingList[1].url
					var picture3 = this.fileList2
					var picture4 = this.huajingList[3].url
					var picture5 = this.huajingList[4].url
				}else if(this.index == 3){
					var picture1 = this.huajingList[0].url
					var picture2 = this.huajingList[1].url
					var picture3 = this.huajingList[2].url
					var picture4 = this.fileList2
					var picture5 = this.huajingList[4].url
				}else if(this.index == 4){
					var picture1 = this.huajingList[0].url
					var picture2 = this.huajingList[1].url
					var picture3 = this.huajingList[2].url
					var picture4 = this.huajingList[3].url
					var picture5 = this.fileList2
				}
				console.log(picture1,picture2,picture3,picture4,picture5,this.detailData.id)
				
				var res = await this.$http.post('/v1/official/manag/environment/update',{
					request:{
						id:this.detailData.id,
						picture1,
						picture2,
						picture3,
						picture4,
						picture5
					}
				})
				console.log(JSON.stringify(res))
				if(res.data.code == 0){
					this.$message.success('修改成功')
				}else{
					this.$message.error(res.data.message)
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.submitBtn{
		margin-left: 80px;
	}
</style>
